<app-atom-model-counter
	[label]="'counter-label-respondant' | translate"
	[customClass]="'counter-respondant'"
	[loading]="loading"
	[count]="count"
	[iconTpl]="iconTpl"
	[linkFullList]="['/respondant/list']"
></app-atom-model-counter>

<ng-template #iconTpl>
	<i nz-icon nzType="user" nzTheme="outline"></i>
</ng-template>
